import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const Vessel = AiseaApiFactory.get("vessel");

export default {
  /**
   * APIから船舶データを取得
   *
   * @param context
   * @param vesselId
   * @returns {*}
   */
  fetch: (context, vesselId) => {
    return Vessel.getVessel(
      vesselId
    ).then(response => {

      context.commit("CREATE", {
        id: response.data.id,
        data: response.data
      });
    });
  },
  /**
   * 船舶データ削除
   *
   * @param context
   * @param vesselId
   */
  remove: (context, vesselId) => {
    context.commit("REMOVE", vesselId);
  },
  /**
   * 船舶データ全削除
   *
   * @param context
   */
  clear: (context) => {
    context.commit("CLEAR");
  }
}
